import { defineStore } from 'pinia';
import { ref } from 'vue';

const useSocketMetaStore = defineStore('socketMeta', () => {
  const handshakeData: Record<string, any> = ref({});

  function setHandshakeData(payload: Record<string, any>) {
    handshakeData.value = payload;
  }

  return {
    handshakeData,
    setHandshakeData,
  };
});

export default useSocketMetaStore;
